import { FC } from 'react'
import useStyles from './styles'
import { InquireModalProps } from './types'
import { Button, Dialog, DialogContent, Typography } from '@material-ui/core'

const DuplicatedErrorModal: FC<InquireModalProps> = ({ open, setOpen }) => {
  const styles = useStyles()

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog open={open} onClose={handleClose} className={styles.modal} PaperProps={{ style: { padding: '8px' } }}>
      <DialogContent>
        <Typography align='center'>
          This property already exists in your <br/> HomeBase Portfolio View
        </Typography>
      </DialogContent>
      <Button variant='contained' color='primary' style={{ marginTop: '16px' }} onClick={handleClose}>OK</Button>
    </Dialog>
  )
}

export default DuplicatedErrorModal
